"use strict";

var _regeneratorRuntime = require("/var/www/dev/prosper/admin.samsung-prosper.dev.pannovate.net/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _DocumentsModel = _interopRequireDefault(require("../../../models/DocumentsModel"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

var RequestInfo = /*#__PURE__*/function (_Component) {
  _inherits(RequestInfo, _Component);

  function RequestInfo(props) {
    var _this;

    _classCallCheck(this, RequestInfo);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(RequestInfo).call(this, props));
    _this.state = {
      documents: []
    };
    return _this;
  }

  _createClass(RequestInfo, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this._loadData();
    }
  }, {
    key: "_loadData",
    value: function () {
      var _loadData2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var documents;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return new _DocumentsModel["default"]().getDocumentsList();

              case 2:
                documents = _context.sent;

                try {
                  this.setState({
                    documents: documents.data
                  });
                } catch (e) {
                  console.log(e);
                }

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function _loadData() {
        return _loadData2.apply(this, arguments);
      }

      return _loadData;
    }()
  }, {
    key: "renderDocuments",
    value: function renderDocuments() {}
  }, {
    key: "render",
    value: function render() {
      var process = this.props.process;
      return _react["default"].createElement("div", {
        className: "main"
      }, _react["default"].createElement("div", {
        className: "dark-blur"
      }), _react["default"].createElement("div", {
        className: "customers-info"
      }, _react["default"].createElement("div", {
        className: "customer-details"
      }, _react["default"].createElement("div", null, _react["default"].createElement("h2", {
        className: "customer-name"
      }, _react["default"].createElement("span", {
        className: "company"
      }, "Request Info"))), _react["default"].createElement("div", null, _react["default"].createElement("div", {
        className: "bottom",
        style: {
          alignItems: 'center'
        }
      }))), _react["default"].createElement("div", {
        className: "customers-main"
      }, _react["default"].createElement("div", {
        className: "row"
      }, _react["default"].createElement("div", {
        className: "col"
      }, _react["default"].createElement("div", {
        className: "padded"
      }, _react["default"].createElement("div", {
        className: "row text-white"
      }, _react["default"].createElement("div", {
        className: "col-lg-6"
      }, _react["default"].createElement("div", {
        style: {
          marginBottom: 20
        }
      }, _react["default"].createElement("h3", null, "Basic Info"), _react["default"].createElement("hr", null), _react["default"].createElement("dl", null, _react["default"].createElement("dt", null, "First name:"), _react["default"].createElement("dd", null, process.firstName), _react["default"].createElement("dt", null, "Last name:"), _react["default"].createElement("dd", null, process.lastName), _react["default"].createElement("dt", null, "E-mail address:"), _react["default"].createElement("dd", null, process.email), _react["default"].createElement("dt", null, "DOB:"), _react["default"].createElement("dd", null, process.birthDay))), _react["default"].createElement("div", {
        style: {
          marginBottom: 20
        }
      }, _react["default"].createElement("h3", null, "Address Info"), _react["default"].createElement("hr", null), _react["default"].createElement("dl", null, _react["default"].createElement("dt", null, "Address Line One:"), _react["default"].createElement("dd", null, process.addressOne), _react["default"].createElement("dt", null, "Address Line Two:"), _react["default"].createElement("dd", null, process.addressTwo), _react["default"].createElement("dt", null, "City:"), _react["default"].createElement("dd", null, process.city), _react["default"].createElement("dt", null, "Postcode:"), _react["default"].createElement("dd", null, process.postCode), _react["default"].createElement("dt", null, "Country:"), _react["default"].createElement("dd", null, process.countryName)))), _react["default"].createElement("div", {
        className: "col-lg-6"
      }, _react["default"].createElement("div", {
        style: {
          marginBottom: 20,
          minHeight: '200px'
        }
      }, _react["default"].createElement("h3", null, "Documents"), _react["default"].createElement("hr", null)), _react["default"].createElement("div", {
        style: {
          marginBottom: 20
        }
      }, _react["default"].createElement("h3", null, "KYC"), _react["default"].createElement("hr", null), _react["default"].createElement("dl", null, _react["default"].createElement("dt", null, "Status:"), _react["default"].createElement("dd", null, process.status.split('_').join(' ').toUpperCase())))))))))));
    }
  }]);

  return RequestInfo;
}(_react.Component);

exports["default"] = RequestInfo;